import {
	SentimentDissatisfiedOutlined as SentimentDissatisfiedOutlinedIcon,
	SentimentNeutralOutlined as SentimentNeutralOutlinedIcon,
	SentimentSatisfiedAltOutlined as SentimentSatisfiedAltOutlinedIcon,
} from '@mui/icons-material'

import GraphicsPanel from './GraphicsPanel'

const getToneMeta = (tone) => {
	if (tone === 'positive') {
		return {
			icon: SentimentSatisfiedAltOutlinedIcon,
			className: 'scout-graphics-summary__icon scout-graphics-summary__icon--positive',
		}
	}

	if (tone === 'negative') {
		return {
			icon: SentimentDissatisfiedOutlinedIcon,
			className: 'scout-graphics-summary__icon scout-graphics-summary__icon--negative',
		}
	}

	return {
		icon: SentimentNeutralOutlinedIcon,
		className: 'scout-graphics-summary__icon scout-graphics-summary__icon--neutral',
	}
}

const GraphicsSummaryList = ({ items = [], empty = false, panelStyle, bodyStyle, listStyle }) => {
	return (
		<GraphicsPanel title="Resumos" empty={empty || !items.length} style={panelStyle} bodyStyle={bodyStyle}>
			<div className="scout-graphics-summary" style={listStyle}>
				{items.map((item) => {
					const toneMeta = getToneMeta(item.tone)
					const ToneIcon = toneMeta.icon

					return (
						<article key={item.id} className="scout-graphics-summary__item">
							<div className={toneMeta.className}>
								<ToneIcon fontSize="inherit" />
							</div>
							<div className="scout-graphics-summary__content">
								<strong>{item.name}</strong>
								<p>{item.summary}</p>
							</div>
						</article>
					)
				})}
			</div>
		</GraphicsPanel>
	)
}

export default GraphicsSummaryList